import React, { useEffect, useState, useContext } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import DateTImeDiv from '../../atoms/Div/DateTImeDiv';
import Paper from '@material-ui/core/Paper';
import { AppContext } from '../../../App';
import { useModal } from '../../../function/useModal';
import ConfirmDialog, { ConfirmDialogResponse } from '../../atoms/Dialog/ConfirmDialog';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';

const useStyles = makeStyles({
  paper: {
    height: '100%',
    background: '#f4d700',
    color: '#000000',
    textAlign: 'center',
  },
});

const UserNameCard: React.FC = () => {
  const history = useHistory();
  const classes = useStyles();
  const { login } = useContext(AppContext);
  const [flgMsgDlg, actMsgDlg] = useModal<ConfirmDialogResponse>();
  const [dlgtitle, setDlgtitle] = useState<string>('');
  const [dlgmsg, setDlgmsg] = useState<string>('');
  const [actionDisp, setActionDisp] = useState<string>('');
  const [cancelDisp, setCancelDisp] = useState<string>('');
  const { t } = useTranslation();

  const cfmdlg = flgMsgDlg ? (
    <ConfirmDialog dialog={actMsgDlg} title={dlgtitle} message={dlgmsg} action={actionDisp} cancel={cancelDisp} />
  ) : null;

  const onClickName = () => {
    setDlgtitle(t('Logout.確認', '確認'));
    setDlgmsg(t('Logout.ログアウトしますか?', 'ログアウトしますか?'));
    setActionDisp(t('Logout.はい', 'ログアウト'));
    setCancelDisp(t('Logout.いいえ', 'いいえ'));
    actMsgDlg
      .open()
      .apply((resp) => {
        //画面遷移
        history.push({
          pathname: '/',
        });
        login.logout();
      })
      .cancel((resp) => {});
  };

  //console.debug(['- 画面描画開始 -', login]);
  return (
    <>
      <Paper className={classes.paper} onClick={(e) => onClickName()}>
        <Typography variant="h6">{login.ID}</Typography>
      </Paper>
      {cfmdlg}
    </>
  );
};

export default UserNameCard;
